import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import gql from 'graphql-tag';
import useQuery from '../../../../modules/react/hooks/useQuery';
import { showStyleModalTab, closeSiteStylesModal } from '../../../web/store/modules/pageBuilder';
import BrandingModal from '../../../../admin/components/BrandingModal';
import FacilitySelectLabel from '../../../../admin/components/FacilitySelectLabel';

const GET_DATA = gql`
  query GetFacilityById($id: ID!) {
    facility(id: $id) {
      id
      primaryImageMediumId
      displayName
      address {
        address1
        address2
        city
        state
        postal
        fullAddress
      }
      linkOutUrl
      theme {
        enabled
        colors {
          primary
          secondary
          tertiary
        }
        logo {
          path
          mediumId
          alt
          title
        }
      }
      socialMedia {
        enabled
        platforms {
          enabled
          link
          provider
        }
      }
    }
  }
`;

const propTypes = {
  initialTab: PropTypes.string.isRequired,
  onDismiss: PropTypes.func.isRequired,
  facilityId: PropTypes.string,
};

const defaultProps = {
  facilityId: undefined,
};

const AdminSiteStylesModalContainer = ({
  initialTab,
  onDismiss,
  facilityId,
}) => {
  const [initFacility, setInitFacility] = useState();
  const { data } = useQuery(GET_DATA, {
    variables: { id: facilityId },
    skip: !facilityId,
    fetchPolicy: 'network-only',
  });
  useEffect(() => {
    if (data && data.facility) {
      const { facility } = data;
      const { id, displayName, address: { fullAddress } } = facility;
      setInitFacility({
        ...facility,
        label: <FacilitySelectLabel disabled={false} facility={facility} />,
        value: id,
        searchField: `${displayName} ${fullAddress}`,
      });
    }
  }, [data]);
  return <BrandingModal initFacility={initFacility} initialTab={initialTab} onDismiss={onDismiss} />;
};

AdminSiteStylesModalContainer.propTypes = propTypes;
AdminSiteStylesModalContainer.defaultProps = defaultProps;

const mapStateToProps = state => ({
  initialTab: showStyleModalTab(state),
  facilityId: state.pageBuilder.facilityId,
});

const mapDispatchToProps = dispatch => ({
  onDismiss: () => dispatch(closeSiteStylesModal()),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(AdminSiteStylesModalContainer);
